import './App.css';
//import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavBar from './components/navbar';
//import Homepage from './components/homepage';
import RmList from './components/rmlist/Rmlist';
import Nopage from './components/nopage/Nopage';
import Calls from './components/calls';
import Dashboard from './components/dashboard';
import Settings from './components/settings';

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<NavBar />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />}/>
        <Route path="calls" element={<Calls />} />
        <Route path="rmList" element={<RmList />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Nopage />} />
      </Route>
    </Routes>

  </BrowserRouter>
  );
}

export default App;
